import {
    LogoutOutlined, UsbOutlined, UserOutlined, InfoCircleOutlined, ShopOutlined
} from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import React from 'react';
import { isAuthenticated, getLoginUser } from '../../utils/session'
import { logout } from '../../utils/session';
import { withRouter } from '../../utils/router'
import { OBJECT_STORAGE_URL } from '../../utils/constants'

class UserMenu extends React.Component {
    state = {
        currentKey: "0",
        avatar: OBJECT_STORAGE_URL.DEFAULT_USER_AVATAR,
    }

    updatePage(path) {
        this.props.router.navigate(path);
    }

    logoutUser() {
        logout();
        this.props.router.navigate('/');
    }

    render() {
        const user = getLoginUser();
        let notLogin = (
            <Button onClick={() => this.updatePage('/login')} type="primary" shape="round" style={{ height: "30px", marginTop: "10px", color: "#03b8cf", backgroundColor: "#ddf3f5" }}>登录</Button>
        );
        const items = [
            {
                label: <span style={{ color: '#666' }}>{`你好 ${user.username}`}</span>,
                key: '0',
            }, {
                type: 'divider',
            }, {
                label: <a href="/manage"><ShopOutlined />&nbsp;我的空间</a>,
                key: '5',
            }, {
                type: 'divider',
            }, {
                label: <a href="/profile/info"><UserOutlined />&nbsp;个人中心</a>,
                key: '1',
            }, {
                label: <a href="/profile/update"><InfoCircleOutlined />&nbsp;更新信息</a>,
                key: '2',
            }, {
                label: <a href="/profile/password"><UsbOutlined />&nbsp;修改密码</a>,
                key: '3',
            }, {
                label: <span onClick={() => this.logoutUser()}><LogoutOutlined />&nbsp;退出登录</span>,
                key: '4',
            }
        ];

        let login = (
            <Dropdown menu={{ items }}>
                <img style={{ width: "30px", height: "30px" }} src={user.avatar || OBJECT_STORAGE_URL.DEFAULT_USER_AVATAR} alt="" />
            </Dropdown>
        );

        return (
            isAuthenticated() ? login : notLogin
        )
    }
}

export default withRouter(UserMenu)